import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from "js-cookie";

// Files
import svCommon from './i18n/sv.json';
import enCommon from './i18n/en.json';
import noCommon from './i18n/no.json';

import { Config } from "../biz/data/Config";

const resources = {
    sv: { translation: svCommon },
    en: { translation: enCommon },
    no: { translation: noCommon },
};

const LANGUAGE_COOKIE_KEY = 'lang';
const defaultFallbackLanguage = "sv";

const COOKIE_DOMAIN: string = ".ohgarden.se";
const getCookie = () => Cookies.get(LANGUAGE_COOKIE_KEY) ?? "";
const setCookie = (e: string) => {
    if (Config.isDev) {
        Cookies.set(LANGUAGE_COOKIE_KEY, e, { expires: 365, sameSite: 'lax' });
    } else {
        Cookies.set(LANGUAGE_COOKIE_KEY, e, { expires: 365, sameSite: 'lax', domain: COOKIE_DOMAIN });
    }
};

// funcs
const getLanguage = () => {
    //  navigator.language || navigator.userLanguage;  => 'sv-SE'
    const browserLang = navigator.language?.substring(0, 2);

    const cookieLang = getCookie();

    var langsAvailable = Object.keys(resources);

    // From Previous set cookie
    if (langsAvailable.indexOf(cookieLang) >= 0) {
        setCookie(cookieLang);
        console.log("Language from cookie:", cookieLang);
        return cookieLang;
    }

    // From prowser language
    if (langsAvailable.indexOf(browserLang) >= 0) {
        console.log("Language from browser:", browserLang);
        return browserLang;
    }

    return defaultFallbackLanguage;
}

// Hook
export const useResources = () => {
    return {
        availableLanguageKeys: Object.keys(resources),
        switchTo: (lang: string) => {
            setCookie(lang);
            i18n.changeLanguage(lang);
        },
        current: i18n.language,
        getLanguageFlag: (e: string) => "/gfx/flags/" + e + ".svg",
    }
}

// Init
i18n
    .use(initReactI18next)
    .init({
        resources: resources,
        lng: getLanguage(),
        fallbackLng: defaultFallbackLanguage,
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });
